import React, { createContext, useContext, useEffect, useState } from "react";
import client from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = async () => {
        const token = localStorage.getItem("noexcuse_token");
        if (!token) {
            setUser(null);
            setLoading(false);
            return;
        }
        try {
            const { data } = await client.get("/auth/me");
            setUser(data);
        } catch (e) {
            localStorage.removeItem("noexcuse_token");
            setUser(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        refresh();
    }, []);

    const login = async (email, password) => {
        const { data } = await client.post("/auth/login", { email, password });
        localStorage.setItem("noexcuse_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const register = async (name, email, password) => {
        const { data } = await client.post("/auth/register", { name, email, password });
        localStorage.setItem("noexcuse_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try {
            await client.post("/auth/logout");
        } catch {}
        localStorage.removeItem("noexcuse_token");
        setUser(null);
    };

    return (
        <AuthCtx.Provider value={{ user, setUser, loading, login, register, logout, refresh }}>
            {children}
        </AuthCtx.Provider>
    );
}

export function useAuth() {
    return useContext(AuthCtx);
}
